/** Bars shown on the "STEM disciplines" card before the expanded-view modal. */
export const STEM_DISCIPLINES_COLLAPSED_BAR_COUNT = 3;
